import { FCX, SelectSingle } from "@datassential/platform-ui-lib";
import cn from "classnames";
import "./CategoryProfileSelect.styles.scss";

export interface CategoryProfileSelectOption {
    id: number;
    title: string;
}

interface Props {
    options: CategoryProfileSelectOption[];
    value: number;
    setValue: (id: number) => void;
}

const CategoryProfileSelect: FCX<Props> = ({
    options,
    value,
    setValue,
    className,
    testId,
}) => {
    return (
        <SelectSingle
            className={cn("CategoryProfileSelect", className)}
            value={value}
            setValue={setValue}
            options={options}
            dropdownProps={{
                place: 'bottom-start',
            }}
            fieldProps={{
                style: { minWidth: 140 },
            }}
            testId={testId}
        />
    );
};

export default CategoryProfileSelect;
